import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UiRadioTabs = _resolveComponent("UiRadioTabs")!
  const _component_PhoneNumberSelect = _resolveComponent("PhoneNumberSelect")!
  const _component_UiButton = _resolveComponent("UiButton")!
  const _component_UiForm = _resolveComponent("UiForm")!
  const _component_ElDialog = _resolveComponent("ElDialog")!

  return (_openBlock(), _createBlock(_component_ElDialog, {
    onClosed: _ctx.closeDialog,
    customClass: "is-confirmation",
    modelValue: _ctx.isOpened,
    destroyOnClose: ""
  }, {
    default: _withCtx(() => [
      _createVNode(_component_UiForm, { onSubmit: _ctx.submit }, {
        default: _withCtx(() => [
          _createVNode(_component_UiRadioTabs, {
            label: "Forwarding type",
            name: "type",
            noValidate: true,
            modelValue: _ctx.formData.type,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.type) = $event)),
            disabled: _ctx.loading,
            options: [
					{ title: 'Let call through', value: 3 },
					{
						title: 'Forward to phone number',
						value: 1
					}
				]
          }, null, 8, ["modelValue", "disabled"]),
          (_ctx.formData.type === 1)
            ? (_openBlock(), _createBlock(_component_PhoneNumberSelect, {
                key: 0,
                label: "Destination",
                inputName: "destination",
                modelValue: _ctx.formData.destination,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.destination) = $event))
              }, null, 8, ["modelValue"]))
            : _createCommentVNode("", true),
          _createVNode(_component_UiButton, null, {
            default: _withCtx(() => [
              _createTextVNode("Save Changes")
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["onSubmit"])
    ]),
    _: 1
  }, 8, ["onClosed", "modelValue"]))
}